<template>
  <el-dialog
    :title="billsTitle"
    width="60%"
    :visible.sync="addUpdateBillsVisible"
    :append-to-body="true"
    @close="handleCancelAddUpdateBills"
  >
    <el-form
      ref="addUpdateBillsForm"
      :model="addUpdateBillsForm"
      label-width="150px"
    >
      <el-row>
        <el-col :span="11">
          <el-form-item
            label="开票金额(元)："
            prop="invoiceAmountStr"
            :rules="moneyRule"
          >
            <el-input
              v-model="addUpdateBillsForm.invoiceAmountStr"
              :disabled="billsOpenFrom === 'check'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item
            label="开票日期："
            class="date-add-return"
            prop="invoiceDate"
            :rules="{
              required: true,
              message: '请选择开票日期',
              trigger: 'blur',
            }"
          >
            <el-date-picker
              :editable="false"
              value-format="yyyy-MM-dd"
              :disabled="billsOpenFrom === 'check'"
              v-model="addUpdateBillsForm.invoiceDate"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item
            label="发票编号："
            prop="invoiceNo"
            :rules="{
              required: true,
              max: 30,
              message: '请输入发票编号,最多30字',
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="addUpdateBillsForm.invoiceNo"
              :disabled="billsOpenFrom === 'check'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item
            label="发票抬头："
            prop="billHead"
            :rules="{
              required: true,
              max: 50,
              message: '请输入发票抬头,最多50字',
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="addUpdateBillsForm.billHead"
              :disabled="billsOpenFrom === 'check'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item
            label="开票备注："
            prop="remarks"
            :rules="{
              max: 200,
              message: '最多200字',
              trigger: 'blur',
            }"
          >
            <el-input
              type="textarea"
              :rows="4"
              maxlength="200"
              show-word-limit
              :disabled="billsOpenFrom === 'check'"
              v-model="addUpdateBillsForm.remarks"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
      v-if="this.billsOpenFrom !== 'check'"
    >
      <el-button @click="handleCancelAddUpdateBills()">取 消</el-button>
      <el-button
        type="primary"
        @click="handleSaveAddUpdateBills()"
        :disabled="isAddBillsDisabled"
        >确 定</el-button
      >
    </div>
    <div slot="footer" class="dialog-footer" v-else>
      <el-button @click="handleCancelAddUpdateBills()">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    const validateMoney = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入开票金额'));
      } else if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error('请输入最多两位小数且无逗号的数字'));
      } else if (value > 999999999.99) {
        callback(new Error('最大999999999.99'));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      moneyRule: {
        required: true,
        validator: validateMoney,
        trigger: 'blur',
      },
      isAddBillsDisabled: false,
      addUpdateBillsVisible: false,
      billsOpenFrom: '',
      billsTitle: '',
      billsId: '',
      addUpdateBillsForm: {
        invoiceAmountStr: '',
        invoiceDate: '',
        invoiceNo: '',
        remarks: '',
        detailed: [],
        billHead: '',
      },
      delBillsDetailed: [],
    };
  },
  props: {
    detailId: String,
  },
  methods: {
    ...mapActions({
      saveAddReturn: 'compact/saveAddReturn',
      saveUpdateReturn: 'compact/saveUpdateReturn',
    }),
    handleCancelAddUpdateBills(isRefresh) {
      this.addUpdateBillsVisible = false;
      this.delBillsDetailed = [];
      this.$refs.addUpdateBillsForm.resetFields();
      if (isRefresh) {
        this.isRefresh = true;
        this.$emit('getCompactDetail', { id: this.detailId });
        this.$emit('handleGetBillsRecord');
        // this.getCompactDetail({ id: this.detailId });
        // this.handleGetBillsRecord();
      }
    },
    // 保存新增或修改回款记录
    handleSaveAddUpdateBills() {
      this.$refs.addUpdateBillsForm.validate((valid) => {
        if (valid) {
          this.isAddBillsDisabled = true;
          if (this.billsOpenFrom === 'add') {
            this.saveAddReturn({
              contractId: this.detailId,
              ...this.addUpdateBillsForm,
            })
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '发票记录新增成功！',
                });
                this.handleCancelAddUpdateBills(true);
              })
              .finally(() => {
                setTimeout(() => {
                  this.isAddBillsDisabled = false;
                }, 1000);
              });
          } else if (this.billsOpenFrom === 'update') {
            this.saveUpdateReturn({
              delDetailed: this.delDetailed,
              id: this.billsId,
              ...this.addUpdateBillsForm,
            })
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '发票记录修改成功！',
                });
                this.handleCancelAddUpdateBills(true);
              })
              .finally(() => {
                setTimeout(() => {
                  this.isAddBillsDisabled = false;
                }, 1000);
              });
          }
        }
      });
    },
    handleCancelAddUpdate(isRefresh) {
      this.addUpdateReturnVisible = false;
      this.delDetailed = [];
      this.$refs.addUpdateBillsForm.resetFields();
      if (isRefresh) {
        this.isRefresh = true;
        this.$emit('getCompactDetail', { id: this.detailId });
        this.$emit('handleGetBillsRecord');
        // this.getCompactDetail({ id: this.detailId });
        // this.handleGetBillsRecord();
      }
    },
  },
};
</script>
